import styles from "./contact.module.scss";
import { BsFillChatSquareTextFill, BsFillSendFill } from "react-icons/bs";
import { zodResolver } from "@hookform/resolvers/zod";
import { createContactSchema } from "../../services/contactUsValidation";

import { Button, Form, Input, Textarea } from "cdhs-ui-library";
import ContactUs from "../../components/ContactUs/ContactUs";
import { contactInfo } from "../../store/user/userSlice";

import { useTranslations } from "../../contexts/LanguageContext";
import { SubmitHandler } from "react-hook-form";
import { ContactRequest, IStatus } from "../../types";
import { useAppDispatch } from "../../store/store";
import { useState } from "react";
import { ErrorSuccessMessage } from "../../components/ErrorSuccessMessage/ErrorSuccessMessage";

function Contact() {
  const t = useTranslations();
  const contactSchema = createContactSchema(t)
  const dispatch = useAppDispatch()
  const [subjectValue, setSubjectValue] = useState<string>("Question about W-9")
  const [requestStatus, setRequestStatus] = useState<IStatus>({
    loading: false,
    error: undefined,
    success: undefined,
  });

  const handleSubject = (event: React.ChangeEvent<HTMLSelectElement>)=>{
    setSubjectValue(event.target.value)
    console.log("subject: ", subjectValue)
  }

  const submitForm: SubmitHandler<ContactRequest> = async (data) => {
    setRequestStatus({ loading: true, error: undefined, success: undefined });
    console.log("DATA ", data)
    await dispatch(contactInfo({ ...data, Subject: subjectValue })).unwrap().then(() => {
      setRequestStatus({
        loading: false,
        success: t("contactPage_successMsg", "Someone will contact you shortly in regards to this request"),
      });
    })
      .catch((error) => {
        console.error(error)
        setRequestStatus({
          loading: false,
          error: error?.Message || t("contactPage_errorMsg", "An unknown error occurred. Please try again."),
        });

      })

  };
  return (
    <>
      <section className={styles.overlay} aria-labelledby="contact-page-section-heading">
        <div className={styles.mainContainer}>
          <div className={styles.icon} aria-hidden="true">
            <BsFillChatSquareTextFill />
          </div>
          <header className={styles.header}>
            <h1 id="contact-page-main-heading">{t('contactPage_mainTitle', 'Have questions or need help with your log in?')}</h1>
            <p>
              {t('contactPage_introTextPart1', 'Send us a message or reach out to one of our contacts')}
            </p>
          </header>
          <ErrorSuccessMessage error={requestStatus.error} success={requestStatus.success} loading={requestStatus.loading} />
          
          <Form onSubmit={submitForm} validationSchema={zodResolver(contactSchema)}>
            <div className={styles.formContent}>
              <fieldset className={styles.formSection}>
                <legend className={styles.visuallyHidden}>
                  {t('contactPage_yourInfoSectionTitle', 'Your info')}
                </legend>
                <Input
                  name="FirstName"
                  label={t('contactPage_firstNameLabel', 'First Name*')}
                  variant="NYTD"
                />
                <Input
                  name="LastName"
                  label={t('contactPage_lastNameLabel', 'Last Name*')}
                  variant="NYTD"
                />
                <Input
                  name="Email"
                  type="email"
                  label={t('contactPage_emailLabel', 'Email*')}
                  variant="NYTD"
                />
              </fieldset>

              <fieldset className={styles.formSection}>
                <legend className={styles.visuallyHidden}>
                  {t('contactPage_messageSectionTitle', 'Message')}
                </legend>
                <div className={styles.dropDownContainer}>
                <label htmlFor="Subject">Subject*</label>
                <select id="Subject" value={subjectValue}name="Subject" className={styles.dropDown} onChange={(e)=>handleSubject(e)}>
                  <option value="Question about W-9">Question about W-9</option>
                  <option value="Log in help">Log in help</option>
                  <option value="Other">Other</option>
                </select>
                </div>
                <Textarea
                  name="Message"
                  label={t('contactPage_yourMessageLabel', 'Your Message*')}
                  variant="NYTD"
                  aria-required="true"
                />
              </fieldset>

              <Button
                caption={t('contactPage_sendMessageButton', 'Send message')}
                type="submit"
                iconPosition="Right"
                disabled={requestStatus.loading}
                variant="NYTD"
                image={<BsFillSendFill />}
                size="large"
              />
            </div>
          </Form>
        </div>
      </section>
      <ContactUs />
    </>
  );
}

export default Contact;
